import React from "react";
import { withNavigation } from '../Components/helpers/withNavigation';
import Body from "../Components/layout/Body";
import TrainingNavigation from "../Components/layout/TrainingNavigation";
import {CheckListContent, CheckListPageControls} from '../Components/layout/CheckListPage';
import { Form } from 'reactstrap';
import '../App.css';
import {v4 as uuid} from 'uuid';
import AudioCapturePopup from '../Components/helpers/AudioCapturePopup';
import { TourProvider } from '@reactour/tour';
import { TourBridge, SkipHiddenTourSteps } from '../utils/TourHelpers';

function CheckListStepWithTour(props){
  const steps= [
    {
      selector:'.function-bar',
      content:(
      <>
        <p>- Home makes the app go back to selecting trainings on the homepage</p>
        <p>- Help to show this tour again.</p>
      </>
      ),
    },
    {
      selector: '.instruct-navigation-listgroup',
      content:(
      <>
        <p>- This is the navigation sidebar showing the steps in the current training.</p>
        <p>- You can select any step to navigate directly to it.</p>
      </>
      ),
    },{
      selector: '.main-form',
      content:(
        <>
          <p>- This is the main content area showing the checklist for the current training step.</p>
          <p>- Select Audio narration describing benefits to add an audio narration for this step.</p>
        </>
      ),
    },
    {
      selector: '.instruct-control-container',
      content:(
        <>
          <p>- Use the Next Step button to proceed to the next step in the training.</p>
          <p>- If you have a video model for this step, you can add or edit it using the Video Model button.</p>
        </>
      ),
    }
  ]
  return (
    <div className={'training-container'}>
      <TourProvider 
        steps={steps} 
        showBadge={false}
        padding={10} 
        scrollSmooth 
        className="my-custom-tour" 
        onClickClose={() => {props.updateState({showTour: false});}} 
        onClickMask={() => {props.updateState({showTour: false});}} 
      >
        <SkipHiddenTourSteps/>
        <TourBridge showTour={props.showTour} incognitoBrowser={props.incognitoBrowser} updateState={props.updateState}>
          <CheckListStep {...props} />
        </TourBridge>
      </TourProvider>
    </div>
  );
}


class CheckListStep extends React.Component {
  constructor(props){
    super(props);
    const saveMessage = {
      icon:'success',
      title:'Progress Saved',
      label: '',
      message: '',
      duration: 3000
    };

    this.state = {
      saveMessage: saveMessage
    }
  }

  onNextClick = () => {
    const curURL = new URL(window.location.href);
    if(this.props.uiInUse === 'UI: Accordion'){
      this.props.navigate({
        pathname: '/main-accordion',
        search: curURL.search
      });
      return;
    }
    var nextCheckListItem = this.props.currentTraining?.CheckList?.find(item => item.Index === this.props.currentStep.Step + 1);
    var nextCheckListStep = this.props.currentTraining?.Steps?.find(step => step.Step === this.props.currentStep.Step + 1 && step.StepType === 3);
    const curHasVideoModel = this.props.currentTraining?.Steps?.some(step => step.Step === this.props.currentStep.Step && step.StepType === 4);
    if(!nextCheckListStep || nextCheckListItem?.Step !== nextCheckListStep.Title){
      if(nextCheckListItem){
        nextCheckListStep = {
          id: uuid(),
          Index: this.props.currentStep.Index + (curHasVideoModel ? 2 : 1),
          Title: nextCheckListItem.Step,
          Step: nextCheckListItem.Index,
          StepType: 3,
        }
      }else if(!nextCheckListStep){
         if(this.props.currentStep?.Title === "Review Checklist"){
          let conclusionStep = this.props.currentTraining?.Steps?.find(step => step.StepType === 2 && step.InfoSlideType === 2);
          if(!conclusionStep) {
            conclusionStep = {
              id: uuid(),
              Index: this.props.currentStep.Index + (curHasVideoModel ? 2 : 1),
              Title: this.props.currentTraining?.Title + " Conclusion",
              Information: '',
              StepType: 2,
              InfoSlideType: 2,
            };
          }
          const currentStep = conclusionStep;
          this.props.updateState({currentStep});
          this.props.navigate({
            pathname: '/information-step',
            search: curURL.search
          });
          return;

        }else{
          nextCheckListStep = {
            id: uuid(),
            Index: this.props.currentStep.Index + (curHasVideoModel ? 2 : 1),
            Title: 'Review Checklist',
            Step: this.props.currentStep.Step + 1,
            StepType: 3,
          };
        }
      }
    }
    const currentStep = nextCheckListStep;
    this.props.updateState({currentStep, tempMessage: this.state.saveMessage});
    this.setState({currentStep: nextCheckListStep.Index});
  }

  onHandleGoToVideoModel = () => {
    var videoStep = this.props.currentTraining?.Steps?.find(step => step.Step === this.props.currentStep.Step && step.StepType === 4);
    if(!videoStep) {
      videoStep = {
          id: uuid(),
          Index: this.props.currentStep.Index + 1,
          Title: this.props.currentStep.Title,
          Step: this.props.currentStep.Step,
          StepType: 4,
      };
    }
    const currentStep = videoStep;
    this.props.updateState({currentStep, tempMessage: this.state.saveMessage});
    const curURL = new URL(window.location.href);
    this.props.navigate({
      pathname: '/video-model-step',
      search: curURL.search
    });
  }

  onNavigationClick = (selectedStep) => {
    if(this.props.uiInUse === 'UI: Accordion'){
      return;
    }
    const currentStep = selectedStep;
    this.props.updateState({currentStep, tempMessage: this.state.saveMessage});
    if(currentStep.StepType === 2){
      const curURL = new URL(window.location.href);
      this.props.navigate({
        pathname: '/information-step',
        search: curURL.search
      });
    }
  }

  render() {
    console.log("rendering CheckListStep, with props: ", this.props + " state: ", this.state);
    if(!this.props.currentTraining){
      return (<div><p>No training selected.</p></div>);
    }
    const nextStepText = this.props.uiInUse === 'UI: Accordion' ? 'Return to Overview' : (this.props.currentStep?.InfoSlideType === 2 ? 'Finish' : 'Next Step');
    const videoModelText = this.props.currentTraining?.Steps?.some(step => step.Step === this.props.currentStep.Step && step.StepType === 4) ? 'Edit Video Model' : 'Add Video Model';
    const videoModelVisible = this.props.uiInUse !== 'UI: Accordion';
    const audioButtonText = this.props.currentStep?.AudioFilepath ? 'Edit Step Audio Narration' : 'Add Step Audio Narration';
    return (
      <Body
        contentComponent={
          <Form id='main-form' className='main-form'>
            <div               
              id='content-container' 
              className='content-container justify-content-center align-items-center'>
                  <CheckListContent 
                    steps={this.props.currentTraining?.CheckList}
                    currentStep={this.props.currentStep?.Title || ''}
                    trainingTitle={this.props.currentTraining?.Title}
                  />
            </div>
          </Form>
        }
        sidebarComponent={
          <TrainingNavigation
            steps={this.props.currentTraining?.Steps}
            currentStep={this.props.currentStep?.Index}
            handleItemClick={this.onNavigationClick}
          />
        }
        controlsComponent={
          <CheckListPageControls 
            videoModelVisible={videoModelVisible}
            handleGoToVideoModel={this.onHandleGoToVideoModel}
            NextStepText={nextStepText}
            videoModelText={videoModelText}
            handleNextClick={this.onNextClick}
            currentTraining={this.props.currentTraining}
            currentStep={this.props.currentStep}
            updateState={this.props.updateState}
            audioButtonText={audioButtonText}
          />
        }
      />
    );
  }
}
export default withNavigation(CheckListStepWithTour);